import { useSimpleError as useError } from '@ts-private/apollo-tools';
import { useToast } from 'hooks/toasts/useToast';

export const useSimpleError = () => {
  const addToast = useToast();
  const showError = useError((message, type, correlationId) => addToast(message, type, { autoClose: true }, correlationId));
  return showError;
};
